import { render, staticRenderFns } from "./BidUploadModal.vue?vue&type=template&id=67de0d54&"
import script from "./BidUploadModal.vue?vue&type=script&lang=js&"
export * from "./BidUploadModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports